module.exports = __webpack_public_path__ + "img/standapp_main.926a796b.svg";